const generateProjectNameShort = (projectName: string) => {
    return projectName.slice(0,2).toUpperCase();
}

export {
    generateProjectNameShort
}